import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';

// Ducks
import AuthReducer from './ducks/AuthDuck';
import storage from 'redux-persist/lib/storage';

const rootReducer = combineReducers({
    auth: AuthReducer
});

const persistConfig = {
    key: 'root',
    storage: storage,
    whitelist: ['auth']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(
    persistedReducer,
    compose(
        applyMiddleware(thunk),
        typeof window === 'object' &&
            typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined'
            ? window.__REDUX_DEVTOOLS_EXTENSION__()
            : f => f
    )
);

export default store;
export const persistor = persistStore(store);
